import {
  MBReactionsAndSeenBy,
  MBReactionsAndSeenByProps,
} from '../components/message/bubble/components/reactionsAndSeenBy';
import { useSelectedReactions, useToggleReaction } from './hooks';

type OwnProps = Omit<MBReactionsAndSeenByProps, 'onToggleReaction' | 'selected'> & {
  channelSlug: string;
};

export function MBMessageReactionsAndSeenBy({
  message,
  channelSlug,
  layout,
  align,
  isDM,
  pickerBottomMargin,
  marginTop,
}: OwnProps) {
  const toggleReaction = useToggleReaction(message, channelSlug);
  const selected = useSelectedReactions(message);

  return (
    <MBReactionsAndSeenBy
      message={message}
      selected={selected}
      onToggleReaction={toggleReaction}
      layout={layout}
      align={align}
      isDM={isDM}
      pickerBottomMargin={pickerBottomMargin}
      marginTop={marginTop}
    />
  );
}
